import { useI18n } from 'i18n/hooks/useI18n';
import { ListingViewSection } from 'modules/listing/components/ListingView/Section/ListingViewSection';
import { ListingRichTextTruncatedHtmlWithLinks } from 'modules/listing/components/RichText/ListingRichTextTruncatedHtmlWithLinks';

type Props = {
  benefits: string | null;
  benefitsTruncated: string | null;
  onToggleDetails?: (isOpen: boolean) => void;
};

export function ListingViewBenefitsSection({
  benefits,
  benefitsTruncated,
  onToggleDetails,
}: Props) {
  const { i18n } = useI18n();

  if (!benefits || !benefitsTruncated) return null;

  return (
    <ListingViewSection
      title={
        /* TRANSLATORS: Listing Page, section title */
        i18n('Benefits')
      }
    >
      <ListingRichTextTruncatedHtmlWithLinks
        showMoreLinkTitle={i18n('Read more about benefits')}
        showLessLinkTitle={i18n('Read less about benefits')}
        html={benefits}
        truncatedHtml={benefitsTruncated}
        onToggle={onToggleDetails}
        toggleQAId="show-listing-benefits-toggle"
      />
    </ListingViewSection>
  );
}
